import { render } from "./Home_Message.vue?vue&type=template&id=f43e0160"
import script from "./Home_Message.vue?vue&type=script&lang=js"
export * from "./Home_Message.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Downloads\\nm_sportips-inscriptions-main\\nm_sportips-inscriptions-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__